import React from "react";

function ProgressBar({ progress, color, isSolid, outlinedColor, handleSeek }) {
  const progressBarRef = React.useRef(null);

  const handleClick = (event) => {
    event.stopPropagation()
    const progressBar = progressBarRef.current;
    if (progressBar) {
      const boundingRect = progressBar.getBoundingClientRect();
      const clickX = event.clientX - boundingRect.left;
      const totalWidth = progressBar.clientWidth;
      const clickPercentage = (clickX / totalWidth) * 100;

      // Call the handleSeek function with the clickPercentage
      if (handleSeek) {
        handleSeek(clickPercentage);
      }
    }
  };

  return (
    <div
      className="progressBar"
      style={{ background: !isSolid ? outlinedColor : "" }}
      onClick={handleClick}
      ref={progressBarRef}
    >
      <div
        className="progressBar__progress"
        style={{
          width: progress >= 99.5 ? "0%" : `${progress}%`,
          background: color,
        }}
      ></div>
    </div>
  );
}

export default ProgressBar;
